module.exports = __webpack_public_path__ + "img/article_white_48dp.6fe70f06.svg";